import { Link } from 'react-router-dom';
import { buttonClass } from '@/components/ui/Button';
import { config } from '@/config/env';
import { useI18n } from '@/hooks/useI18n';
import styles from './FinalCta.module.css';

export function FinalCta() {
  const { t } = useI18n();
  const cta = t.marketing.finalCta;

  return (
    <section className={styles.section} id="cta-final">
      <div className={['ilu-container', styles.inner].join(' ')}>
        <h2 className={styles.headline}>{cta.headline}</h2>
        <p className={styles.body}>{cta.body}</p>
        <div className={styles.ctas}>
          <Link to="/contacto" className={buttonClass({ variant: 'primary', size: 'lg' })}>
            {cta.ctaLabel}
          </Link>
          <a
            href={`mailto:${config.contactEmail}`}
            className={buttonClass({ variant: 'outline', size: 'lg' })}
          >
            {config.contactEmail}
          </a>
        </div>
      </div>
    </section>
  );
}
